"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var OperatorDropdownBody_1 = require("./OperatorDropdownBody");
var react_intl_1 = require("react-intl");
var operatorItems = [
    { value: "TOP", translationId: "rankingFilter.top" },
    { value: "BOTTOM", translationId: "rankingFilter.bottom" },
];
var getOperatorItemTranslation = function (operator) {
    return operatorItems.find(function (_a) {
        var value = _a.value;
        return value === operator;
    }).translationId;
};
var OperatorDropdownComponent = function (_a) {
    var selectedValue = _a.selectedValue, onSelect = _a.onSelect, intl = _a.intl;
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var onButtonClick = function () {
        setIsOpen(!isOpen);
    };
    var onItemSelect = function (value) {
        onSelect(value);
        setIsOpen(false);
    };
    var buttonClassNames = classnames_1.default("gd-button-secondary", "gd-button-small", "button-dropdown", "gd-icon-right", {
        "gd-icon-navigateup": isOpen,
        "gd-icon-navigatedown": !isOpen,
    }, "gd-rf-operator-dropdown-button", "s-rf-operator-dropdown-button");
    var title = intl.formatMessage({ id: getOperatorItemTranslation(selectedValue) });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(sdk_ui_kit_1.Button, { className: buttonClassNames, value: title, onClick: onButtonClick }),
        isOpen && (react_1.default.createElement(OperatorDropdownBody_1.OperatorDropdownBody, { items: operatorItems, selectedValue: selectedValue, onSelect: onItemSelect, onClose: function () { return setIsOpen(false); } }))));
};
exports.OperatorDropdown = react_intl_1.injectIntl(OperatorDropdownComponent);
//# sourceMappingURL=OperatorDropdown.js.map